import React from "react"
import styled from "styled-components"
import theme from "../../../styles/theme"
import bodyStyles from "./bodyStyles"

const { breakPoints: { screenQuery } } = theme

const Body3 = styled.p(bodyStyles, `
  font-size: 18px;
  line-height: 22px;
  ${screenQuery.large}{
    font-size: 16px;
    line-height: 20px;
  }
  ${screenQuery.small}{
    font-size: 14px;
    line-height: 20px;
  }
  p {
    font-size: 18px;
    line-height: 22px;
    ${screenQuery.large}{
      font-size: 16px;
      line-height: 20px;
    }
    ${screenQuery.small}{
      font-size: 14px;
      line-height: 20px;
    }
  }
`)

export default ({
  children,
  ...props
}) => (
    <Body3
      {...props}
    >
      {children}
    </Body3>
  )
